import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { Spinner, Table } from "reactstrap";
import { GET_ADMIN_QUERIES } from "../../../graphql/valuelist-gql";
import { IValueList, IValueListAdminQuery, IValueListQueriesResponse } from "../../../types/valuelist";
import './style.scss';
import SpinnerOverlay from "../../common/spinner/spinner";

const SavedQueriesTable = (props: {
  onSelect: (user: IValueListAdminQuery | undefined) => void
}) => {
  const { onSelect } = props;

  const [selectedItem, setSelectedItem] = useState<IValueListAdminQuery>();

  const { data, loading } = useQuery<IValueListQueriesResponse>(GET_ADMIN_QUERIES);

  useEffect(() => onSelect(selectedItem), [selectedItem]);

  function rowClicked(query: IValueListAdminQuery) {
    if(query.id === selectedItem?.id) return;
    
    setSelectedItem(query);
  }

  return loading ? <SpinnerOverlay /> : (
    <section className="overflow-y-auto scrollable-query-list">
      <Table striped hover>
        <thead>
          <tr>
            <th>Query Title</th>
          </tr>
        </thead>
        <tbody>
          {data?.getAdminQueries.map((query) => {
            const isSelected = query.id === selectedItem?.id;
            return <tr key={query.id}
              className={isSelected ? 'table-primary' : 'pe-force action-link'}
              onClick={() => rowClicked(query)}>
              <td>{query.label}</td>
            </tr>
          })}
        </tbody>
      </Table>
    </section>
  );
};

export default SavedQueriesTable;
